import { memo } from 'react';
import moment from 'moment';
import { IPublicRequestMetersData } from 'app/pages/request-single-page/request-single-page-slice';
import { VStack } from 'app/pages/request-single-page/components-v4';
import { MeterBadge, MeterDateInfo } from './ui';

export const Meter = memo((meter: IPublicRequestMetersData) => {
  const now = moment();
  const checkDate = moment(meter.check_date);
  const lastReadingDate = meter.last_readings[0]?.date
    ? moment(meter.last_readings[0].date)
    : null;

  const isOverdueCheck = checkDate.isSameOrBefore(now.clone().add(3, 'months')); //Дата поверки истекает менее, чем через 3 месяца
  const isOverdueReading = lastReadingDate
    ? lastReadingDate.isBefore(now.clone().subtract(3, 'months'))
    : false; //Дата сдачи показаний была более 3 месяцев назад

  return (
    <VStack spacing="xs">
      <MeterBadge {...meter} />

      {!meter.is_automatic && (
        <MeterDateInfo
          title="Дата сдачи"
          date={lastReadingDate}
          isOverdue={isOverdueReading}
          emptyText="Вы ещё не сдавали показания"
        />
      )}

      <MeterDateInfo
        title="Дата поверки"
        date={checkDate}
        isOverdue={isOverdueCheck}
      />
    </VStack>
  );
});
